module.exports = __webpack_public_path__ + "static/media/mobile-stripes-partner.fa2176a0.svg";